import React from 'react';
import PropTypes from 'prop-types';

import { ContainerConsumer } from '../app';

const DependencyConsumer = ({ name, children: render }) => (
  <ContainerConsumer>
    {container => render(container.get(name))}
  </ContainerConsumer>
);

DependencyConsumer.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
};

export default DependencyConsumer;



// WEBPACK FOOTER //
// ./src/components/DependencyConsumer.js